window.initLottiePlayerComponent = function(id) {
    let isStarted = false;
    const player = document.getElementById(id);
    // start the animation when user scroll into view
    jQuery(window).on('scroll', function() {
        const playerTop = player.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (playerTop < windowHeight && !isStarted) {
            console.log('Starting the lottie animation...');
            isStarted = true;
            player.play();
        }
    });
    player.addEventListener('ready', () => {
        const svg = player.shadowRoot.querySelector('svg');
        svg.style.transform = 'scale(1.19)';
    });
    player.addEventListener('complete', function() {
        console.log('Animation completed');
        player.pause();
        setTimeout(() => {
            player.seek(0);
            player.play();
        }, 5000); // 5 seconds delay before replay
    });
}